var Detail = /** @class */ (function () {
    function Detail() {
    }
    return Detail;
}());
export { Detail };
var DetailProperty = /** @class */ (function () {
    function DetailProperty() {
    }
    return DetailProperty;
}());
export { DetailProperty };
var FormProperties = /** @class */ (function () {
    function FormProperties() {
    }
    return FormProperties;
}());
export { FormProperties };
var TransportValueSelection = /** @class */ (function () {
    function TransportValueSelection() {
    }
    return TransportValueSelection;
}());
export { TransportValueSelection };
var OptionsGroup = /** @class */ (function () {
    function OptionsGroup() {
    }
    return OptionsGroup;
}());
export { OptionsGroup };
var Options = /** @class */ (function () {
    function Options() {
    }
    return Options;
}());
export { Options };
var PropertyValidation = /** @class */ (function () {
    function PropertyValidation() {
    }
    return PropertyValidation;
}());
export { PropertyValidation };
var ValueSelection = /** @class */ (function () {
    function ValueSelection() {
    }
    return ValueSelection;
}());
export { ValueSelection };
var DetailPropertyGroup = /** @class */ (function () {
    function DetailPropertyGroup() {
    }
    return DetailPropertyGroup;
}());
export { DetailPropertyGroup };
var DetailSection = /** @class */ (function () {
    function DetailSection() {
    }
    return DetailSection;
}());
export { DetailSection };
var GroupAction = /** @class */ (function () {
    function GroupAction() {
    }
    return GroupAction;
}());
export { GroupAction };
var Action = /** @class */ (function () {
    function Action() {
    }
    return Action;
}());
export { Action };
var InfoCard = /** @class */ (function () {
    function InfoCard() {
    }
    return InfoCard;
}());
export { InfoCard };
var InfoCardSection = /** @class */ (function () {
    function InfoCardSection() {
    }
    return InfoCardSection;
}());
export { InfoCardSection };
var AttachmentSummary = /** @class */ (function () {
    function AttachmentSummary() {
    }
    return AttachmentSummary;
}());
export { AttachmentSummary };
var CombinationProperty = /** @class */ (function () {
    function CombinationProperty() {
    }
    return CombinationProperty;
}());
export { CombinationProperty };
